interface WelcomePageProps {
  onNavigate: (page: string) => void;
  user: any;
}

export default function WelcomePage({ onNavigate, user }: WelcomePageProps) {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="w-full max-w-lg text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-amber-500/20 to-amber-600/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-amber-500/20">
          <svg className="w-10 h-10 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl md:text-4xl font-extrabold mb-3">
          <span className="bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent">Welcome</span>
          <span className="text-white"> to ScribeHaven!</span>
        </h1>

        <p className="text-gray-400 text-lg mb-8 max-w-md mx-auto">
          Your email has been verified and your account is fully activated. You now have access to all platform features.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 max-w-sm mx-auto text-left">
          <div className="flex items-center gap-3 bg-gray-900/50 rounded-xl p-3 border border-gray-800">
            <span className="text-xl shrink-0">📖</span>
            <div>
              <p className="text-sm font-medium text-white">Discover Stories</p>
              <p className="text-xs text-gray-500">Across 29 genres</p>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-gray-900/50 rounded-xl p-3 border border-gray-800">
            <span className="text-xl shrink-0">✍️</span>
            <div>
              <p className="text-sm font-medium text-white">Write & Publish</p>
              <p className="text-xs text-gray-500">Share your stories</p>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-gray-900/50 rounded-xl p-3 border border-gray-800">
            <span className="text-xl shrink-0">🏆</span>
            <div>
              <p className="text-sm font-medium text-white">Join Contests</p>
              <p className="text-xs text-gray-500">Win Ink prizes</p>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-gray-900/50 rounded-xl p-3 border border-gray-800">
            <span className="text-xl shrink-0">✦</span>
            <div>
              <p className="text-sm font-medium text-white">Tip Authors</p>
              <p className="text-xs text-gray-500">500 Ink to start</p>
            </div>
          </div>
        </div>

        <div className="flex gap-4 justify-center">
          <button
            onClick={() => onNavigate('discover')}
            className="px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-gray-950 rounded-xl font-bold transition-all shadow-lg shadow-amber-500/20"
          >
            Start Reading
          </button>
          <button
            onClick={() => onNavigate('dashboard')}
            className="px-6 py-3 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-xl font-semibold transition-colors"
          >
            Start Writing
          </button>
        </div>
      </div>
    </div>
  );
}
